import React from 'react';
import SectionTitle from '../components/SectionTitle';
import './stylings/AboutUs.css';
import { TeamMember } from '../components/AboutUs/TeamMember';

export class AboutUs extends React.Component {
	render() {
		return (
			<section className="about-us__section animated fadeIn">
				<div className="container">
					<SectionTitle title="Über uns" />
					<p>
						Die Ursprungsidee Koblenz Kompass wurde Ende 2013 von Amrei und Katha ins Leben gerufen, 
						mit der Aussicht einen Stadtführer mit Blogcharakter von und für KoKos zu entwickeln.
					</p>
					<p>
						Das heißt einen virtuellen Ort zu schaffen an dem gebündelt persönliche Sichtweisen und 
						Geheimtipps für Orte, Locations und Veranstaltungen zu finden sind.
						Mit Koblenz Kompass möchten wir die Möglichkeit bieten sich zu vernetzen und neue Ideen 
						für Koblenzer Kulturszene zu schaffen, um das volle Koblenzer Potenzial auszuschöpfen.
					</p>
					
					<p>
						Den Blick ins Detail zu richten, besondere auf den ersten Anschein nach Unscheinbare und 
						Verborgene Orte zu entdecken und über sie mit unserer ganz individuellen Sichtweise zu 
						berichten, ist uns eine Herzensangelegenheit. Kreative Köpfe, wie Künstler und ungewöhnliche 
						Geschäftsideen in den Fokus zu nehmen, gemeinsam neue Kultur zu schaffen und sich auf 
						beachtenswerte gegenwärtige Kultur zu konzentrieren.
					</p>
					<p>
						Das Gesamtpaket Koblenz Kompass möchte die kreativen Menschen und die Schönheit der Stadt 
						in der WIR leben eine Plattformbieten und dafür möchten wir als Team mit all unseren 
						unterschiedlichen Fähigkeiten und Talenten beitragen.
						Koblenzern und Koblenzliebhabern möchten wir immer wieder die Möglichkeit geben die eigene 
						Stadt neu zu entdecken und die Perspektive auf die Stadt in der WIR leben zu schärfen.
					</p>
					<p>
						Hierzu soll sich ein jeder Koblenz-liebhabende berufen fühlen, den eigenen Ideen freien 
						Lauf zu lassen um sich damit an uns zu wenden, die Ideen zu teilen und uns Fragen zu stellen.
						Wir als Team haben uns seit Mitte 2017 zusammen gefunden und sind seitdem mit Euphorie und Herz 
						dabei unsere Ideen und Vorstellungen umzusetzen.
					</p>
		{/*
					<div className="team-section">
						<SectionTitle title="Aktuelles Team" />
						<ul className="row">
							<TeamMember memberName="Alina" memberRole="Radlende Reporterin" />
							<TeamMember memberName="Daniel" memberRole="IT-Boy" />
							<TeamMember memberName="Isa" memberRole="Knipslicht" />
							<TeamMember memberName="Katrin" memberRole="Schreibfee" />
							<TeamMember memberName="Marius" memberRole="Der mit der Klampfe" />
						</ul>
					</div>
		*/}
				</div>
			</section>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/AboutUs.js